import React from 'react';
import { theme } from 'antd';

interface StatCardGridProps {
  children: React.ReactNode;
  /** Narrowest card width before the grid wraps to fewer columns. */
  minCardWidth?: number;
}

/**
 * Responsive row of `StatCard`s: as many equal columns as fit, two per row on phones.
 */
export function StatCardGrid({ children, minCardWidth = 200 }: StatCardGridProps) {
  const { token } = theme.useToken();
  const gap = token.marginSM + 4;

  return (
    <div
      className="stat-card-grid"
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(min(${minCardWidth}px, calc(50% - ${gap / 2}px)), 1fr))`,
        gap,
        marginBottom: token.marginLG
      }}
    >
      {children}
    </div>
  );
}

export default StatCardGrid;
